import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonProps } from '@bonusly/design-system';

import { useActionInput } from '../../context';
import { useIsEnabled } from '../../hooks/use-is-enabled';
import { insertTrigger } from '../../lib/insert-trigger';
import { DecorationButton } from './decoration-button';
import { useDecorationTagSchema } from './hooks/use-decoration-tag-schema';
import { DecorationTag } from './types';

interface DecorationTagButtonProps extends ButtonProps {
	tag: DecorationTag;
	decorationVariant?: 'default' | 'list-item';
}

export const DecorationTagButton: FC<DecorationTagButtonProps> = ({ tag, decorationVariant = 'default', ...rest }) => {
	const schema = useDecorationTagSchema(tag);
	const isEnabled = useIsEnabled(tag);
	const { editor } = useActionInput();
	const { t } = useTranslation('action_input');

	if (!isEnabled) {
		return null;
	}

	const handleClick = () => {
		if (editor) {
			insertTrigger(editor, schema.trigger);
		}
	};

	return (
		<DecorationButton label={t(`decorations.${schema.label}`)} onClick={handleClick} decorationVariant={decorationVariant} {...rest}>
			{schema.icon}
		</DecorationButton>
	);
};
